import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './contact.css'
import icon1 from './images/location-dot-solid.svg'
import icon2 from './images/phone-solid.svg'
import icon3 from './images/envelope-solid.svg'
import icon4 from './images/clock-regular.svg'
import NavigationBar from './nav';
import Toggle from '../toggle';
import NewNav from './canvas';
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function Contact() {
  useEffect(()=>{
      Aos.init({duration:"1000"})
    })
  
  return (
    <>
      <Container fluid >
        <Row>
          <NavigationBar />
          <NewNav/>
          <Col style={{overflow:'hidden'}} id='contactTop'>

            <Row>
              <Col style={{overflow:'hidden'}} id='contactHeading'>
                <p data-aos="zoom-in">Contacts</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Container fluid id="conDetail">
        <Row>
          <Col style={{overflow:'hidden'}} md={3} xs={12} id="conHere">
            <div data-aos="zoom-out" >
              <div id='icon'><img src={icon1} /></div>

              <span id="conName">Location</span>
              <span id="contactdes">Perkleaf Cafe, Medical Chowk , Near LOC Cafe , Nagpur- 440009</span>
            </div>
          </Col>

          <Col style={{overflow:'hidden'}} md={3} xs={12} id="conHere">
            <div data-aos="zoom-out" >
              <div id='icon'><img src={icon2} /></div>

              <span id="conName">Phone</span>
              <span>9284661825</span>
            </div>
          </Col>

          <Col style={{overflow:'hidden'}} md={3} xs={12} id="conHere">
            <div data-aos="zoom-out" >
              <div id='icon'><img src={icon3} /></div>

              <span id="conName">Email</span>
              <span>perkleafcoffee@gmail.com</span>
            </div>
          </Col>

          <Col style={{overflow:'hidden',marginBottom:"5%"}} md={3} xs={12} >
            <div data-aos="zoom-out" >
              <div id='icon'><img src={icon4} /></div>

              <span id="conName">Working Hours</span>
              <span>Monday - Sunday<br></br>
                11:00 AM - 10:00 PM</span>
            </div>
          </Col>

        </Row>
        <Row>
          <Col id="location">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.5450173220197!2d79.09579617525945!3d21.130697980544316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c16116d09315%3A0x29d28341ce6565!2sLOC%20%3A%20LIFE%20OF%20CHAI%20MEDICAL%20SQUARE!5e0!3m2!1sen!2sin!4v1750941913303!5m2!1sen!2sin" style={{
              width: "100%", height: "100%", style: "border:0;",overflow:'hidden',
              allowfullscreen: "", loading: "lazy", referrerpolicy: "no-referrer-when-downgrade"
            }}></iframe>
          </Col>
        </Row>
      </Container>

      <Container fluid id='containerForm'>
        <Row>
          <Col style={{overflow:'hidden'}} id='col13'>
          <h1 data-aos="fade-down">Send Message</h1>
          <input id="name" type="text" placeholder='Your name'></input>
          <input id="emm" type="email" placeholder='Your email'></input>
          <div id="mess" ><textarea
            placeholder="Message"
            rows={4} cols={50}
            style={{
              borderRadius: "40px", padding: "25px", width: "100%", border: "1px solid #ccc", resize: "none"
            }}
          /></div>
          <button>Submit</button>
          </Col>
        </Row>
      </Container>
      </>
  )
}

export default Contact